import React, {useContext} from "react";
import {Typography, Space, Button} from "@bezlimit/bezlimit-ui";
import _ from "lodash";
import "./style.scss";
// core
import {LayoutContext, ModalContext} from "../../../core/Contexts";
//images
import attention from "../../../images/exkl.png";
import {useNavigate, useParams} from "react-router-dom";
import ErrorSignUrl from "../errorSignUrl";

export default React.memo(function SuccessSignUrl({link, url}: IProps) {
    const contextLayout = useContext(LayoutContext);
    const contextModal = useContext(ModalContext);
    const params = useParams();
    const navigate = useNavigate();

    const onCancel = () => {
        navigate(`/reservation`);
        contextModal?.setMaskStyle(undefined);
        contextModal?.setCssClass("");
        contextModal?.setVisible(false);
    };

    const onClick = () => {
        if (!!url) {
            contextModal?.setMaskStyle(undefined);
            contextModal?.setCssClass("");
            contextModal?.setVisible(false);
            navigate(`${url?.pathname}${location.search ?? ""}`, {
                state: {
                    link
                }
            });
        } else {
            contextModal?.setMaskStyle({
                background:
                    "linear-gradient(0deg, rgba(100, 40, 120, 0.20) 0%, rgba(100, 40, 120, 0.20) 100%), rgba(0, 0, 0, 0.65)",
                // @ts-ignore
                WebkitBackdropFilter: " blur(12px)",
                backdropFilter: " blur(12px)"
            });
            contextModal?.setCssClass(" bl-modal-success-passport-add");
            contextModal?.setChildren(<ErrorSignUrl />);
            contextModal?.setVisible(true);
            contextModal?.setOnCancel(() => onCancel);
        }
        // navigate(`/reservation`);
        // contextModal?.setMaskStyle(undefined);
        // contextModal?.setCssClass("");
        // contextModal?.setVisible(false);
    };

    return (
        <Typography as="div" className="bl-success-sign-url">
            <Space
                size={_.gte(contextLayout?.width ?? 0, 768) ? 32 : 18}
                direction="vertical"
                align="center"
            >
                {_.gte(contextLayout?.width ?? 0, 768) ? (
                    <img src={attention} width={116} alt="attention" />
                ) : (
                    <img src={attention} width={88} alt="attention" />
                )}

                <Typography as="div" className="title">
                    {"Важно!"}
                </Typography>

                <Typography as="div" className="subtitle">
                    {
                        "Клиент должен лично подписать договор в Вашем \nприсутствии в течении 10 дней после пополнения баланса!"
                    }
                </Typography>

                <Typography as="div" className="text">
                    {
                        "Проверьте правильность заполнения всех данных клиента \nперед подписанием договора!"
                    }
                </Typography>

                <Button type="primary" onClick={onClick}>
                    Подписать договор
                </Button>
            </Space>
        </Typography>
    );
});

interface IProps {
    link?: string;
    url?: any;
}
